var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"input",staticClass:"input",attrs:{"contenteditable":true},on:{"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }